<template>
    <div class="content" ref="content">
        <template v-if="isPc">
            <template  v-if="isWX == true">
                <!-- 试题 -->
                    <div v-if="code == '0' && !isAnswered" class="content_row">
                    <template v-if="dialogVisible == false">
                        <div class="content_center">
                            <AppearancePC 
                                ref="AppearancePC" 
                                id="printExam" 
                                @addEventListener="userAddEventListener" 
                                :quanxian="quanxian" 
                                :bandingstyle="style" 
                                :percentage="percentage" 
                                :data="data"  
                                @submit="submit"
                                :isBank="isBank"
                                :isPreviewPc="isPreviewPc"
                            ></AppearancePC>
                            <div class="footer-box" v-if="quanxian.allowBeforePreview == 1">
                                <el-button size="medium" v-print="'#printExam'">预览或打印</el-button>
                            </div>
                        </div>
                    </template>
                    <div v-else-if="dialogVisible" class="tips-box">
                        <p class="title">您之前已经回答了{{answeredNumber}}题，是否继续上次回答？</p>
                        <div class="footer">
                            <el-button size="medium" @click="answerAgain">重新答题</el-button>
                            <el-button size="medium" type="primary" @click="dialogVisible = false">继续答题</el-button>
                        </div>
                    </div>
                    </div>
                <!-- 未到时间 -->
                <el-row v-if="code == '2002' || code == '1001' || isAnswered" :gutter="20" class="content_row">
                    <el-col :span="4"><div class="grid-content bg-purple" style="opacity: 0;">1</div></el-col>
                    <el-col :span="16" class="isNotStartTime">
                        <p class="title" >{{tipTitle}}</p>
                        <p class="tips">{{message}}</p>
                        <p class="date" v-if="examStartTime">此问卷将在{{examStartTime}}开放，请到时再打开此页面！</p>
                    </el-col>
                    <el-col :span="4"><div class="grid-content bg-purple" style="opacity: 0;">1</div></el-col>
                </el-row>
                <!-- 密码 -->
                <el-row v-else-if="code == '2000' || code == '2001'" :gutter="20" class="content_row">
                    <el-col :span="4"><div class="grid-content bg-purple" style="opacity: 0;">1</div></el-col>
                    <el-col :span="16" class="isPassword">
                            <p class="title">请输入考试密码</p>
                            <div class="input_box">
                                <el-input :class="{'input__err': passwordError}" class="input" placeholder="请输入密码" v-model="password" show-password></el-input>
                                <div v-show="passwordError" class="form-item__error">{{passwordErrorTip}}</div>
                            </div>
                            <el-button class="btn" type="primary" @click="confirmPassword">确定</el-button>
                    </el-col>
                    <el-col :span="4"><div class="grid-content bg-purple" style="opacity: 0;">1</div></el-col>
                </el-row>
                <!-- 提交后提示框 -->
                <el-dialog
                    :visible.sync="dialogthinkVisible"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :show-close="false"
                >
                    <div class="submittedSuccess">
                        <p class="title">{{tipTitle}}</p>
                        <p class="tips" v-html="endMsg"></p>
                        <p class="thank">
                            <span v-if="quanxian.findResultParse == 1 || quanxian.showGradeBill == 1 || quanxian.showRanking == 1">点击查看 </span>
                            <span v-if="quanxian.findResultParse == 1 || quanxian.showGradeBill == 1" class="score link" @click="toscore">成绩及解析</span>
                            <span v-if="quanxian.showRanking == 1" class="Ranking-list link" @click="toRankingList">排行榜</span>
                        </p>
                    </div>
                </el-dialog>
                <el-dialog
                    title="您是否继续答题"
                    :visible.sync="continueDialogVisible"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :before-close="continueBeforClose"
                    width="30%">
                    <span>{{autoSubmitTitle}}</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="submit()">提交{{submitCountdown}}</el-button>
                        <el-button type="primary" @click="continueBeforClose">继续答题</el-button>
                    </span>
                </el-dialog>
                <el-dialog
                    :title="`您已离开考试${cutScreenNum}次`"
                    :visible.sync="cutScreenDialogVisible"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :before-close="cutScreenContinue"
                    width="30%">
                    <span>离开次数达到{{quanxian.cutScreenNum}}次将强制交卷</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="cutScreenContinue">继续答题</el-button>
                    </span>
                </el-dialog>
            </template>
            <div v-else-if="isWX == false" class=" isWx-content isWx-content-pc">
                <div  class="isWX-tips-box">
                    <p class="title">您需要在微信中打开才能参与</p>
                    <p class="tips-describe">用微信扫一扫下面的二维码</p>
                    <div class="qrCode" style="">
                        <canvas ref="qrCodeImg" class="qrCode-img"></canvas>
                    </div>
                </div>
            </div>
        </template>
        
        <template v-else>
            <template v-if="isWX == true && wxLogin == false">
                <template v-if="code == '0' && !isAnswered">
                    <template v-if="dialogVisible == false">
                        <AppearanceTM 
                            ref="AppearanceTM" 
                            :percentage="percentage"
                            :bandingstyle="stylePhone" 
                            :quanxian="quanxian" 
                            :data="data" 
                            @addEventListener="userAddEventListener" 
                            @submit="submit"
                            :isBank="isBank"
                        ></AppearanceTM>
                    </template>
                    <div v-else-if="dialogVisible" class="TM-continue-tips-box">
                        <p class="title">您之前已经回答了{{answeredNumber}}题，是否继续上次回答？</p>
                        <div class="footer">
                            <el-button size="medium" @click="answerAgain">重新答题</el-button>
                            <el-button size="medium" type="primary" @click="dialogVisible = false">继续答题</el-button>
                        </div>
                    </div>
                </template>
            
                <!-- 未到时间 -->
                <div v-if="code == '2002' || code == '1001' || isAnswered" class="TM-content">
                    <div  class="TM-tips-box ">
                        <p class="title">{{tipTitle}}</p>
                        <p class="tips">{{message}}</p>
                        <p class="date" v-if="examStartTime">此问卷将在{{examStartTime}}开放，请到时再打开此页面！</p>
                    </div>
                </div>
                <!-- 密码 -->
                <div v-else-if="code == '2000' || code == '2001'"  class="TM-content">
                        <div  class="TM-isPassword">
                        <p class="title">请输入考试密码</p>
                            <div class="input_box">
                                <el-input :class="{'input__err': passwordError}" class="input" placeholder="请输入密码" v-model="password" show-password></el-input>
                                <div v-show="passwordError" class="form-item__error">{{passwordErrorTip}}</div>
                            </div>
                            <el-button class="btn" type="primary" @click="confirmPassword">确定</el-button>
                    </div>
                </div>
                <!-- 提交后提示框 -->
                <el-dialog
                    :visible.sync="dialogthinkVisible"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :show-close="false"
                    width="90%"
                >
                    <div class="TM-submittedSuccess">
                        <p class="title">{{tipTitle}}</p>
                        <p class="tips" v-html="endMsg"></p>
                        <p class="thank">
                            <span v-if="quanxian.findResultParse == 1 || quanxian.showGradeBill == 1 || quanxian.showRanking == 1">点击查看 </span>
                            <span v-if="quanxian.findResultParse == 1 || quanxian.showGradeBill == 1" class="score link" @click="toscore">成绩及解析</span>
                            <span v-if="quanxian.showRanking == 1" class="Ranking-list link" @click="toRankingListTM">排行榜</span>
                        </p>
                    </div>
                </el-dialog>
                <el-dialog
                    class="TM-Dialog"
                    title="您是否继续答题"
                    :visible.sync="continueDialogVisible"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :before-close="continueBeforClose"
                    width="90%">
                    <span>{{autoSubmitTitle}}</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button size="medium" @click="submit()">提交{{submitCountdown ? submitCountdown :''}}</el-button>
                        <el-button size="medium" type="primary" @click="continueBeforClose">继续答题</el-button>
                    </span>
                </el-dialog>
                <el-dialog
                    class="TM-Dialog"
                    :title="`您已离开考试${cutScreenNum}次`"
                    :visible.sync="cutScreenDialogVisible"
                    :close-on-click-modal="false"
                    :close-on-press-escape="false"
                    :before-close="cutScreenContinue"
                    width="90%">
                    <span>离开次数达到{{quanxian.cutScreenNum}}次将强制交卷</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="cutScreenContinue">继续答题</el-button>
                    </span>
                </el-dialog>
            </template>
            <div v-else-if="isWX == false" class="isWx-content">
                <div  class="isWX-tips-box">
                    <p class="title">您需要在微信中打开才能参与</p>
                    <p class="tips-describe">你可复制本页面地址，通过在微信中发送消息来打开</p>
                </div>
            </div>
            <div v-if="wxLogin == true" class="isWx-content">
                <div  class="isWX-tips-box">
                    <p class="title">微信登录后才能参与</p>
                    <el-button class="wx-login" @click="userLoginWX">一键登录</el-button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import QrCode from 'qrcode'
import AppearancePC from './components/appearancePC.vue'
import { mapMutations, mapState } from 'vuex'
import { v1 as UUID } from "uuid";
import AppearanceTM from './components/appearanceTM.vue'
import $ from 'jquery';
import wx from 'weixin-js-sdk'
export default {
    components: {
        AppearancePC,
        AppearanceTM,
    },
    name: 'UserAnswerPC',
    props: {
        isPreviewPc: {
            type: Number,
            default: 0 // 1 手机 2 pc
        },
        isBank: {
            type: Boolean,
            default: false // true 题库预览
        },
    },
    data() {
        return {
            autoSubmitTitle: '若长时间未有任何操作，系统将自动提交考卷',
            wxLogin: false,
            isPc: true,
            id: '',
            percentage: 0,
            customColor: '#50E6A7',
            data: {},
            noAnswerData: {},
            endTime: '',
            list: [],
            style: {// pc端外观
                appearance: {
                    bgImg: '',
                    buttonContent: '提交',
                    displayTitle: 1,
                    displayQuestionsno: 1
                }
            },
            stylePhone: {
                appearancePhone: {
                    bgColor: '',
                    displayTitle: 1,
                    buttonContent: '提交',
                    displayQuestionsno: 1,
                }
            },
            quanxian: {
                title: '234'
            },
            underwayId: '',
            isStartTime: false, // 是否到考试开始时间
            answerExceedTimer: null, // 考试结束超出时间倒计时
            examEnded: false, // 考试已结束
            // storageTimerChange: '',
            password: '',
            showPassword: false,
            passwordError: false,
            passwordErrorTip: '',
            dialogthinkVisible: false,
            examStartTime: '', // 考试开始时间
            code: '',
            message: '',
            dialogVisible: '',
            answeredNumber: 0, // 已答题目数量
            isAnswered: false,
            openId: '',
            WXcode: '',
            // WXtoken: '',
            isWX: true,
            submitCountdown: 10,
            continueDialogVisible: false,
            submitCountdownTimer: null,
            cutScreenNum: 0,
            cutScreenDialogVisible: false,
            isFullFlag: false, // 全屏状态
            tipTitle: '',
            loadingInstance: false,
            wxshareTitle: '', //分享标题
            wxshareContent: '', //分享标题
            uploadSuces: '', //分享标题
            URLObj: {},
            examBrowserUUID: '', // 浏览器唯一标识
            endMsg: '',
            endPageNormalMsg: '',
            endPageAdvanceMsg: '',
            submitState: 0, // 1 已过考试结束时间，强制交卷
        }
    },
    computed:{
		...mapState(['examQuestionTypeArr','headers','examAnswer',]),
	},
    watch:{
    },
    created() {
        // 考试预览 提交无效
        if (this.isPreviewPc == 1) {
            this.isPc = false
        } else if (this.isPreviewPc == 2) {
            this.isPc = true
        } else {
            this.isPc = this.$functions.isPC()
        }
        this.URLObj = this.getUrl(window.location.href)
        // console.log(this.URLObj)
        if (this.URLObj?.id) {
            this.id = this.URLObj.id
        }else {
            this.id = sessionStorage.getItem("examId")
        }
        this.underwayId = this.URLObj?.sampleId ? this.URLObj.sampleId : ''
        // console.log(this.underwayId)
        if (this.underwayId) {
            localStorage.setItem('underwayId', this.underwayId)
        }
        // 考试次数限制 本地存储uuid 传给后端去判断
        if(localStorage.getItem(`${this.id}UUID`)) {
            this.examBrowserUUID = localStorage.getItem(`${this.id}UUID`)
        } else {
            localStorage.setItem(`${this.id}UUID`, UUID())
            this.examBrowserUUID = localStorage.getItem(`${this.id}UUID`)
        }
        
        // 题库预览 提交无效
        if(this.isBank) {
            this.getBankData()
        } else{
            // 考试与考试预览都使用该接口获取试题
            this.getData()
        }

    },
    mounted() {
        // console.log(document.location.href )
        this.disableCopyPaste()
    },
    methods:{
		...mapMutations(['setAxamAnswer',]),
        disableCopyPaste() {
            // 禁止右键菜单（防止通过右键复制）
            document.addEventListener('contextmenu', this.preventEvent)
            
            // 禁止复制（Ctrl+C）
            document.addEventListener('copy', this.preventEvent)
            
            // 禁止剪切（Ctrl+X）
            document.addEventListener('cut', this.preventEvent)
            
            // 禁止粘贴（Ctrl+V）
            document.addEventListener('paste', this.preventEvent)
            
            // 禁止拖拽
            document.addEventListener('dragstart', this.preventEvent)
            document.addEventListener('drop', this.preventEvent)
            
            // 额外：禁止选择文本
            document.addEventListener('selectstart', this.preventEvent)
            // 监听按键事件
            document.addEventListener('keydown', this.preventDevToolsShortcuts)
        },
        
        preventEvent(e) {
            e.preventDefault()
            return false
        },
        preventDevToolsShortcuts(e) {
            const forbiddenKeys = {
                'F12': () => this.handleF12(),
                'F11': () => this.handleF11(e), // 全屏快捷键
                'I': () => this.handleI(e), // Ctrl+Shift+I
                'J': () => this.handleJ(e), // Ctrl+Shift+J
                'C': () => this.handleC(e), // Ctrl+Shift+C
                'U': () => this.handleU(e)  // Ctrl+U
            }
            
            const key = e.key.toUpperCase()
            if (forbiddenKeys[key]) {
                forbiddenKeys[key]()
            }
        },
        handleF12() {
            console.log('F12 已被禁用')
            return false
        },
        
        handleF11(e) {
            if (e.ctrlKey || e.shiftKey) {
                e.preventDefault()
                return false
            }
        },
        
        handleI(e) {
            if (e.ctrlKey && e.shiftKey) {
                e.preventDefault()
                this.showWarning('开发者工具已被禁用')
                return false
            }
        },
        
        handleJ(e) {
            if (e.ctrlKey && e.shiftKey) {
                e.preventDefault()
                return false
            }
        },
        
        handleC(e) {
            if (e.ctrlKey && e.shiftKey) {
                e.preventDefault()
                return false
            }
        },
        
        handleU(e) {
            if (e.ctrlKey) {
                e.preventDefault()
                return false
            }
        },
        getUrl(url) {
            // 先获取href问号以及问号后的内容
            if (url) {
                url = url.substr(url.indexOf("?"))
            } else {
                url = window.location.href
            }
            //判断是否含有问号，有则说明含有参数
            if (url.indexOf("?") !== -1) {
                var str = url.substr(1)
                var strs = str.split("&")
                var obj = new Object()
                // console.log(str)
                // console.log(strs)
                for (var i = 0; i < strs.length; i++) {
                    if (strs[i].split("=")[1].indexOf('#') != -1) {
                        obj[strs[i].split("=")[0]] = strs[i].split("=")[1].split('#')[0]
                    } else {
                        obj[strs[i].split("=")[0]] = strs[i].split("=")[1]
                    }
                }
                return obj
            }
            return null
        },
        // 是否为微信浏览器
        isWeiXin(){
            //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
            var ua = window.navigator.userAgent.toLowerCase();
            // alert(JSON.stringify(ua))
            //通过正则表达式匹配ua中是否含有MicroMessenger字符串
            if(ua.match(/MicroMessenger/i) == 'micromessenger'){
                return true;
            } else{
                return false;
            }
        },
        // 微信卡片分享
    	createWxSignature() {
            // alert('createWxSignature')
			let that = this;
			let appId = "";
			let timestamp = ""; // 必填，生成签名的时间戳
			let nonceStr = ""; // 必填，生成签名的随机串
			let signature = ""; // 必填，签名
			let title = that.$functions.filterHtmlTag(that.wxshareTitle) // 分享标题
			let desc = that.$functions.filterHtmlTag(that.wxshareContent) // 分享描述
			let link = document.location.href // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
			let imgUrl = that.uploadSuces // 分享图标

			let url = `${this.$config.service.createSignature}?url=${encodeURIComponent(location.href.split('#')[0])}`;
			// console.log('url', url)
			$.ajax({
				type: "GET",
				url: url,
				dataType: "",
				success(res) {
                    
                // alert(`微信信息:${JSON.stringify(res)}`)
				// console.log('微信信息', res)
				// console.group("调用微信分享接口api");
				appId = res.resultBody.appId; // 必填，公众号的唯一标识
				timestamp = res.resultBody.timestamp; // 必填，生成签名的时间戳
				nonceStr = res.resultBody.noncestr; // 必填，生成签名的随机串
				signature = res.resultBody.signature; // 必填，签名
				
                // alert(`res.code:${res.code}`)
				if (res.code == 0) {
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: appId, // 必填，公众号的唯一标识
						timestamp: timestamp, // 必填，生成签名的时间戳
						nonceStr: nonceStr, // 必填，生成签名的随机串
						signature: signature, // 必填，签名
						jsApiList: [
							"updateAppMessageShareData",
							"updateTimelineShareData",
						], // 必填，需要使用的JS接口列表
					});
					wx.ready(function() {
					//需在用户可能点击分享按钮前就先调用
						console.group("微信 ready");
						wx.updateAppMessageShareData({
							title: title, // 分享标题
							desc: desc, // 分享描述
							link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: imgUrl, // 分享图标
							success: function() {
								// alert("分享成功")
								console.log("分享成功");
							},
						});
						wx.updateTimelineShareData({
							title: title, // 分享标题
							desc: desc, // 分享描述
							link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: imgUrl, // 分享图标
							success: function() {
								// alert("分享成功")
								console.log("分享成功");
							},
						});
						console.groupEnd();
					});

					wx.error(function(res) {
						// alert("微信错误")
						console.group("微信错误");
						// console.log(res)
						console.groupEnd();
						// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
					});
				}
				// console.log(res);
				console.groupEnd();
				},
			});
    	},
        // 判断浏览器是否处于全屏状态
        checkFull() {
            //判断浏览器是否处于全屏状态 （需要考虑兼容问题）
            //火狐浏览器
            var isFull =
                document.mozFullScreen ||
                document.fullScreen ||
                //谷歌浏览器及Webkit内核浏览器
                document.webkitIsFullScreen ||
                document.webkitRequestFullScreen ||
                document.mozRequestFullScreen ||
                document.msFullscreenEnabled;
            if (isFull === undefined) {
                isFull = false;
            }
            return isFull;
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement
            if (this.isFullFlag) {
                if (document.exitFullscreen) {
                document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
                }
                
            //     // this.isFullFlag = !this.isFullFlag;
            } else {
                if (element.RequestFullScreen) {
                    element.RequestFullScreen()
                } else 
                if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen()
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen()
                } else if (element.msRequestFullscreen) {
                // IE11
                    element.msRequestFullscreen()
                }
            }
            
        },
        // 监听用户是否有新操作
        userAddEventListener(start){
            this.submitState = start
            this.handleonmousedown()
            window.addEventListener('mousedown', () =>this.handleonmousedown())
            window.addEventListener('scroll', () =>this.handleonmousedown())
            window.addEventListener('keyup', () =>this.handleonmousedown())
        },
        // 清除监听新操作
        userRemoveEventListener() {
            window.removeEventListener('mousemove', () =>this.handleonmousedown())
            window.removeEventListener('scroll', () =>this.handleonmousedown())
            window.removeEventListener('keyup', () =>this.handleonmousedown())
            if (this.answerExceedTimer) {
                clearTimeout(this.answerExceedTimer)
                this.answerExceedTimer = null
            }
            if (this.submitCountdownTimer) {
                clearInterval(this.submitCountdownTimer)
                this.submitCountdownTimer = null
            }
        },
        handleonmousedown() {
            let isShowNotice = false
            if (this.isPc) {
                isShowNotice = this.$refs.AppearancePC.isShowNotice
            } else {
                isShowNotice = this.$refs.AppearanceTM.isShowNotice
            }
            console.log('isShowNotice :>> ', isShowNotice);
            if (isShowNotice){
                return
            }
            console.log('狀態',this.submitState)
            // this.submitState 1 考试结束时间已过，超过this.quanxian.examrExceedTime秒时强制交卷
            let timer = null
            if (this.answerExceedTimer) {
                clearTimeout(this.answerExceedTimer)
                this.answerExceedTimer = null
            }
            if (this.submitState == 1) {
                timer = this.quanxian.examrExceedTime
                this.autoSubmitTitle = '考试结束后，系统将自动提交考卷'
            } else {
                timer = this.quanxian.answerExceedTime
                this.autoSubmitTitle = '若长时间未有任何操作，系统将自动提交考卷'
            }
            console.log('timer :>> ', timer);
            this.answerExceedTimer = setTimeout(()=> {
                // 提交试卷接口
                // console.log('交卷')
                    this.continueDialogVisible = true
                    this.$nextTick(() => {
                        const countdownTimerId = setInterval(() => {
                            this.submitCountdown--
                            if (this.submitCountdown == 0) {
                                clearInterval(countdownTimerId)
                                this.submitCountdownTimer = null
                                this.submit()
                            }
                        }, 1000)
                        this.submitCountdownTimer = countdownTimerId
                    })
                clearTimeout(this.answerExceedTimer)
                this.answerExceedTimer = null
            }, timer * 1000)
        },
        continueBeforClose(){
            // console.log('continueBeforClose')
            this.continueDialogVisible = false
            if (this.submitCountdownTimer) {
                clearInterval(this.submitCountdownTimer)
                this.submitCountdownTimer = null
                this.submitCountdown = 10
                this.handleonmousedown()
            }
        },
        // 切屏检测
        cutScreenCheck () {
            window.addEventListener('resize', this.resizeMonitor)
            window.addEventListener('blur', this.documentBlur)
            window.onresize = () => {
                if (!this.checkFull()) {
                    // 退出全屏后要执行的动作
                    if(this.cutScreenNum < this.quanxian.cutScreenNum) {
                        this.resizeMonitor()
                        this.isFullFlag = false
                    }
                } else {
                    this.isFullFlag = true
                }
            }
        },
        // 清除监听切屏事件
        cutScreenCheckRemove() {
            this.cutScreenNum = 0
            window.removeEventListener('resize', this.resizeMonitor)
            window.removeEventListener('blur', this.documentBlur)
        },
        documentBlur() {
            this.cutScreenNum++
            if (!this.dialogthinkVisible) {
                this.cutScreenDialogVisible = true
                if(this.cutScreenNum == this.quanxian.cutScreenNum) {
                    this.submit()
                }
            }
        },  
        resizeMonitor() {
                if(!this.checkFull() && !this.dialogthinkVisible) {
                    // console.log('resizeMonitor')
                    if (this.cutScreenDialogVisible == false) {
                        this.cutScreenDialogVisible = true
                        this.cutScreenNum++
                    }
                }
            
            if(this.cutScreenNum == this.quanxian.cutScreenNum) {
                this.submit()
            }
        },
        // 触发是否继续答题弹窗
        cutScreenContinue() {
            if (this.isFullFlag == false) {
                this.handleFullScreen()
            }
            this.cutScreenDialogVisible = false
        },
        // 获取微信静默微信登录code
        loginWX() {
            let state = JSON.stringify({
                    id: this.id
                })
            this.WXcode = this.URLObj.code
            let redirect_uri = `http://wx.outh.ai-learning.net/?sys=${this.$functions.getWXSys()}&id=${this.id}#/userAnswerPC`
            // console.log(`redirect_uri:${redirect_uri}`)
            // alert(`未编码：${redirect_uri}`)
            redirect_uri = encodeURIComponent(redirect_uri)
            // alert(`state：${state}`)
            let url =  `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe56ce182843a7957&response_type=code&scope=snsapi_base&redirect_uri=${redirect_uri}#wechat_redirect`
            // alert(`微信code:${this.WXcode}`)
            if (this.WXcode == null || this.WXcode === '') { // 如果没有code，则去请求
                // alert(`未获取到code`)
                window.location.href = url
            } else {
                // alert(`已获取到code`)
                this.getOpenId()
            }
        },
        getOpenId() {
            // alert('获取openid方法')
            // console.log( `${this.$config.service.WXgetOpenId}?code=${this.WXcode}`)
            let that = this;
            let params = {
                that: this,
                url: `${this.$config.service.WXgetOpenId}?code=${this.WXcode}`,
                method: "get",
                cb(res) {
                    // alert(`res.code:${res.code}`)
                    // alert(`openid:${res.resultBody.openId}`)
                    if (res.code == '0') {
                        that.openId = res.resultBody.openId
                        // ofoPW585tvQHnIvlUSFfTtZSvyVY
                        // alert(`that.id:${that.id}`)
                        that.getData()
                    }
                },
            };
            
            params.isnologin = true
            this.$util.request(params);
        },
        userLoginWX() {
            // alert(`获取微信info:userLoginWX`)
            this.wxLogin = false
            this.WXcode = this.URLObj.code
            let redirect_uri = `http://wx.outh.ai-learning.net?sys=${this.$functions.getWXSys()}&id=${this.id}#/userAnswerPC`
            redirect_uri = encodeURIComponent(redirect_uri)
            let url =  'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe56ce182843a7957&response_type=code&scope=snsapi_userinfo&redirect_uri='+redirect_uri+'#wechat_redirect'
            // console.log(url)
            // this.WXcode = '091VrFFa1PRJzD0XhmGa1llz6D1VrFFO'
            if (this.WXcode == null || this.WXcode === '') { // 如果没有code，则去请求
                window.location.href = url
            }
        },
        getWXuserByWeChatLogin() {
            // alert(`获取微信getWXuserByWeChatLogin`)
            // alert(`this.WXcode${this.WXcode}`)
            let that = this;
            let params = {
                that: this,
                url: `${this.$config.service.WXuserByWeChatLogin}?code=${this.WXcode}`,
                method: "get",
                cb(res) {
                    // console.log(res)
                    // alert(`code:${res.code}`)
                    // alert(`openid:${res.resultBody.openId}`)
                    // alert(`token:${res.resultBody.token}`)
                    localStorage.setItem('token', res.resultBody.token)
                    if (res.code == '0') {
                        that.openId = res.resultBody.openId
                        // that.WXtoken = res.resultBody.token
                        // alert(`data:${JSON.stringify(data)}`)
                        that.getData()
                    }
                },
            };
            params.isnologin = true
            this.$util.request(params);
        },
        // 获取参数 带#
        getQueryStringhash(key) {
            let after = window.location.hash.split("?")[1];
            if (after) {
                let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
                let r = after.match(reg);
                if (r != null) {
                    return decodeURIComponent(r[2]);
                }
                else {
                    return null;
                }
            }
        },
        answerAgain() {
            // localStorage.removeItem(this.id)
            this.data = this.noAnswerData
            localStorage.setItem(this.id, this.data.questionsList)
            this.dialogVisible = false
        },
        getBankData() {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examBankGetQuess}?id=${this.id}`,
                method: "GET",
                cb(res) {
                    // console.log(res)
                    if (res.code == '0') {
                        that.code = 0
                        // that.data = JSON.parse(res.resultBody.paperjson)
                        let paper = JSON.parse(res.resultBody.paperjson)
                        that.data.questionsList = paper.questionsList.map((info) => {
                            if (that.$functions.isJSON(info)){
                                return JSON.parse(info)
                            }
                            return info
                        })
                        that.setQuesAnswer()
                    }
                },
            };
            this.$util.request(params);
        },
        getParamsData(data) {
            let obj = {}
            for(let key in data) {
                if (data[key]) {
                    obj[key] = data[key]
                }
            }
            return obj
        },
        getData(state) {
            
                // alert(`token:${localStorage.getItem('token')}`)
            // alert(`data:${JSON.stringify(data)}`)
            let data = {
                surveyId: this.id,
                wxOpenid: this.openId,
                answerPassword: this.password,
                browseOnlyId: this.examBrowserUUID,
                underwayId: this.underwayId
            }
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examUnderwayClickAnswer}`,
                method: "POST",
                data: this.getParamsData(data),
                cb(res) {
                // console.log(res)
                // alert(`code:${res.code}`)
                // alert(`res:${JSON.stringify(res)}`)
                // alert(JSON.stringify(res.resultBody))
                that.code = res.code
                that.message = res.message
                switch (res.code) {
                    case '2001': // 密码型
                        that.showPassword = true
                        if(state == 1) {
                            // that.$message.error('请输入密码')
                            that.passwordError = true
                            that.passwordErrorTip = res.message
                        }
                        break;
                    case '2000': // 密码错误
                        that.passwordError = true
                        that.passwordErrorTip = res.message
                        break;
                    case '1001': // 考试已结束 （错误码）
                        break;
                    case '2002': // 考试未开始
                        that.isStartTime = false
                        that.examStartTime = res.resultBody.examStartTime
                        that.data.title = res.resultBody.tbExamProject.title
                        that.tipTitle = that.$functions.filterHtmlTag(res.resultBody.tbExamProject.title)
                        // that.$message.error(res.message)
                        break;
                    case '2004': // 是否需要微信登录
                        // alert(that.isPc)
                        if(!that.isPc) {
                            that.isWX = true
                            /*
                                *getWxName // (需要微信登录)状态
                            */
                            // alert('是否需要微信登录')
                            if (res.resultBody.getWxName == 1) {
                                // alert('需要微信登录')
                                // 如果有 说明微信登录以获取用户信息
                                if(that.URLObj?.code) {
                                    that.WXcode = that.URLObj.code
                                    that.getWXuserByWeChatLogin()
                                } else {
                                    that.wxLogin = true
                                }
                                
                                // 返回openId、token后在请求试题结构接口
                            }else {
                                // alert('loginWX微信')
                                that.loginWX()
                                // 返回openId后在请求试题结构接口
                            }
                        } else {
                            that.getWxQrCode()
                            that.isWX = false
                        }
                        
                        
                        break;
                    case '0':
                        let arr = [],index = 0, questionsList = [], totalScore = 0
                        that.quanxian = res.resultBody.tbExamProject
						// console.log( '  that.quanxian ', that.quanxian )
                        that.wxshareTitle = res.resultBody.wxShareTitle
                        that.wxshareContent = res.resultBody.wxShareContent
                        that.uploadSuces = res.resultBody.wxSharePicture ? res.resultBody.wxSharePicture : that.$logo

                        that.endPageNormalMsg = res.resultBody.endPageNormalMsg
                        that.endPageAdvanceMsg = res.resultBody.endPageAdvanceMsg
                        
                        if (res.resultBody.tbExamAppearance && res.resultBody.tbExamAppearance.length > 0) {
                            res.resultBody.tbExamAppearance.forEach((info) => {
                                if (info.type == 0) {
                                    // console.log(info)
                                    that.stylePhone.appearancePhone = info.contentjson ? JSON.parse(info.contentjson) : ''
                                } else {
                                    // console.log(info)
                                    that.style.appearance = info.contentjson ? JSON.parse(info.contentjson) : ''
                                }
                            })
                        }
                        // console.log(that.style.appearance)
                        if (res.resultBody.tbExamProject.showTitleNum == ''){
                            that.quanxian.showTitleNum = 0
                        }
                        // 获取一维数组（当前接口返回的是没有页码的二维数组）
                        res.resultBody.jsonArray.forEach((info, index) => {
                            if (index == res.resultBody.jsonArray.length - 1) {
                                questionsList.push(
                                    ...info
                                )
                            } else {
                                questionsList.push(
                                    ...info,
                                    {
                                        questionsTypeId: 402,
                                        questionsName: '页码',
                                        isHideTitle: false
                                    }
                                )
                            }
                        })
                        
                        that.data.title = res.resultBody.title
                        that.tipTitle = that.$functions.filterHtmlTag(res.resultBody.tbExamProject.title)
                        that.data.depict = res.resultBody.description
                        that.data.questionsList = questionsList
                        // console.log( that.data.questionsList)
                        that.data.questionsList.forEach((info) => {
                            if (info.isHideTitle == false){
                                arr.push(info)
                                if (that.examQuestionTypeArr.indexOf(info.questionsTypeId) != -1) {
                                    totalScore = totalScore + parseFloat(info.score)
                                    info.quesIndex = index
                                    index++
                                    that.data.quesCount = index
                                }
                            }
                        })
                        that.data.totalScore = totalScore
                        
                        that.data.questionsList = arr
                        that.list = that.data.questionsList
                        that.underwayId = res.resultBody.underwayId
                        localStorage.setItem('underwayId', res.resultBody.underwayId)
                        // 所有题目重新排列(随机排列除信息题)
                        if(that.quanxian.titleRealign == 1) {
                            that.data.questionsList = that.shuffle(that.data.questionsList)
                        }

                        // 考试次数限制
                        
                        if(localStorage.getItem(`${this.id}UUID`) && that.quanxian.pcPhoneAnswerNumState != 1) {
                            localStorage.removeItem(`${this.id}UUID`)
                        }
                        
                            // 每个题型用户的答题字段在这里就开始设置userAnswer、userAnswerArr
                        that.setQuesAnswer()
                        
                        that.noAnswerData = JSON.parse(JSON.stringify(that.data))
                        // console.log(that.noAnswerData)
                        // console.log(that.data.questionsList)
                        // 断点续答
                        if(that.quanxian.ifNewAnswerPage == 0 && that.quanxian.saveLastContent == 1) {
                            if (localStorage.getItem(that.id)) {
                                // console.log(localStorage.getItem(that.id))
                                that.data.questionsList = JSON.parse(localStorage.getItem(that.id))
                                that.answeredNumber = that.answeredNum(that.data.questionsList)
                                
                                // console.log(that.data.questionsList)
                                if (that.answeredNumber > 0) {
                                    that.dialogVisible = true
                                    // console.log(that.data.questionsList)
                                } else {
                                    that.dialogVisible = false
                                }
                            } else {
                                localStorage.setItem(that.id, JSON.stringify(that.data.questionsList))
                            }
                        } else{
                            that.dialogVisible = false
                        }

                        // 答题超时设置
                        if (that.quanxian.answerExceedState == 1) {
                            that.$nextTick(() => {
                                that.userAddEventListener()
                            })
                        }
                        if (that.quanxian.cutScreenStatus == 1) {
                            {
                                that.$nextTick(() => {
                                    that.cutScreenCheck()
                                })
                            }
                        }
                        break;
                    }
                    // alert(that.isWeiXin())
                    if(that.isWeiXin()) {
                        that.createWxSignature()
                        if (that.examAnswer.id) {
                            that.id = that.examAnswer.id
                            that.underwayId = that.examAnswer.underwayId
                            that.data.questionsList = that.examAnswer.questionsList
                            that.quanxian = that.examAnswer.quanxian
                            that.dialogthinkVisible = that.examAnswer.isSubmitted
                        }
                    }
                }
            };
            params.isnologin = true
            this.$util.request(params)
        },
        // 如果是微信浏览器打开，存储答题结果
        WXViewResults() {
            if (!this.isPc && this.isWeiXin()) {
                let obj = {
                    id: this.id,
                    underwayId: this.underwayId,
                    questionsList: this.data.questionsList,
                    isSubmitted: true,
                    quanxian: this.quanxian
                }
                this.$store.commit('setAxamAnswer', obj);
            }
        },
        setQuesAnswer() {
			let quesTypeArr = [100, 101, 102, 207];
            this.data.questionsList.forEach((info, index) =>{
                if (this.$functions.isJSON(info)) {
                    info = JSON.parse(info)
                }
                this.$set(info, 'validate', false)
                switch (info.questionsTypeId) {
                    case 101: // 多选
                        this.$set(info, 'userAnswerArr', [])
                        this.$set(info, 'validateMsg', '请选择选项')
                        break;
                    case 100:
                    case 102:
                        this.$set(info, 'userAnswer', '')
                        this.$set(info, 'validateMsg', '请选择一个选项')
                        break;
                    case 207: // 多项填空
                    case 208: // 横向填空
                        this.$set(info, 'userAnswer', 0)
                        if (info.optionList.length > 0) {
                            info.optionList.forEach((item, i) => {
                                this.$set(item, 'userAnswer', '')
                                this.$set(item, 'validate', false)
                                this.$set(item, 'validateMsg', '请输入内容')
                            })
                        }
                        break;
                    case 209: // 绘图题
                        this.$set(info, 'userAnswer', '')
                        this.$set(info, 'validateMsg', '请在上方空白区域进行签名，并点击 【完成】 按钮')
                        break;
                    case 210: // 上传文件
                    case 211: // 上传图片
                        this.$set(info, 'fileList', [])
                        this.$set(info, 'userAnswerArr', '')
                        this.$set(info, 'validateMsg', '请上传文件')
                        break;
                    default:
                        this.$set(info, 'userAnswer', '')
                        this.$set(info, 'validateMsg', '请输入内容')
                }
                
                // 选项是否随机
                if (quesTypeArr.indexOf(info.questionsTypeId) !== -1 && info.optionIfRandom == 1) {
                    if (info.ifFixedLastOption == 1) {
                        // 固定最后一个选项
                        info.optionList = this.optionRandom(info.optionList, 1);
                    } else {
                        info.optionList = this.optionRandom(info.optionList);
                    }
                }
            })
        },
        // 选项随机
		optionRandom(array, state) {
			let res = [],
				random,
				quesArr = [],
				lastOptionArr = [];
			if (state == 1) {
				array.forEach((info, index) => {
					if (index == array.length - 1) {
						lastOptionArr.push(info);
					} else {
						quesArr.push(info);
					}
				});
			} else {
				quesArr = array;
			}
			while (quesArr.length > 0) {
				random = Math.floor(Math.random() * quesArr.length);
				res.push(quesArr[random]);
				quesArr.splice(random, 1);
			}
			return [...res, ...lastOptionArr];
		},
        // 获取当前地址的二维码
        getWxQrCode() {
            // console.log(location.href)
            let url = location.href
            // console.log(url)
            this.$nextTick(() =>{
                QrCode.toCanvas(this.$refs.qrCodeImg, url,{
                    width: 200,
                    height: 200
                })
            })
        },
        answeredNum(list){
            let num = 0
            list.forEach(info => {
                if ((info.userAnswerArr && info.userAnswerArr.length > 0) || info.userAnswer ){
                    num++
                }
            })
            // console.log(num)
            return num
        },
        // 查看答案与解析
        toscore() {
            let findResultParse = this.quanxian.findResultParse ? this.quanxian.findResultParse : 0
            let showGradeBill = this.quanxian.showGradeBill ? this.quanxian.showGradeBill : 0
            // console.log('查看答案与解析')
            let routeData = this.$router.resolve({
                path: `/userExamPreview/${this.id}/${this.underwayId}/${findResultParse}/${showGradeBill}`,
      
            })
            // console.log(routeData.href)
            window.open(routeData.href, '_blank')
        },
        // 查看排行榜
        toRankingList() {
            // console.log('查看排行榜')
            let routeData = this.$router.resolve({
                path: '/rankingList',
                query: {
                    userId:this.underwayId,
                    id:  this.id
                }
            })
            window.open(routeData.href, '_blank')
        },
        // 查看排行榜TM
        toRankingListTM() {
            // console.log('查看排行榜')
            let routeData = this.$router.resolve({
                path: '/rankingListTM',
                query: {
                    userId:this.underwayId,
                    id:  this.id
                }
            })
            window.open(routeData.href, '_blank')
        },
        async DrawingUpQiniu(userAnswer) {
            return new Promise(async resolve => {
                let blob = this.dataURLtoBlob(userAnswer)
                let file = new File([blob], "file" + UUID(), {
                    type: blob.type,
                    lastModified: Date.now(),
                })
                // console.log(file)
                var formData = new FormData()
                formData.append('file', file)
			    formData.append('biz', 'upDataKs')
                $.ajax({
                    url: `${this.$config.service.uploadApi}`,
                    type: 'POST',
                    data: formData,
                    miniType: 'multipart/form-data',
                    contentType: false,
                    processData: false,
                    success: await function(data) {
                        // console.log(data.key)
                        resolve(data.message)
                    },
                    error: function() {
                        alert('上传失败！');
                    }
                })
            })
        },
        // base64字符串转换为Blob
        dataURLtoBlob(dataURI) {
            let byteString = atob(dataURI.split(',')[1])
            let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
            let ab = new ArrayBuffer(byteString.length)
            let ia = new Uint8Array(ab)
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)
            }
            return new Blob([ab], { type: mimeString })
        },
        // 绘图题 提交到七牛云end
        async getAnswerList(data) {
            let answerList = []
            // console.log(data)
            for (let i in data) {
                try {
                    if (data[i].questionsTypeId == 100 || data[i].questionsTypeId == 102) {
                        let value = ''
                        data[i].optionList.forEach((item) => {
                            if (item.oid == data[i].userAnswer && item.haveInput == true) {
                                value = `${data[i].userAnswer}:${item.inputValue}`
                            } else if(item.oid == data[i].userAnswer){
                                value = data[i].userAnswer
                            }
                        })
                        answerList.push({
                            qid: data[i].qid,
                            bqid: data[i].bqid ? data[i].bqid : '',
                            value: value ? value : ''
                        })
                    } else if (data[i].questionsTypeId == 101) {
                        // console.log(data[i])
                        let value = '', str = '', arr = []
                        data[i].optionList.forEach((item) => {
                            if (data[i].userAnswerArr.indexOf(item.oid) != -1 && item.haveInput == true) {
                                value = `${item.oid}:${item.inputValue}`
                                arr.push(value)
                            } else if (data[i].userAnswerArr.indexOf(item.oid) != -1){
                                value = item.oid
                                arr.push(value)
                            }
                        })
                        if(arr) {
                            str = arr.join()
                        }
                        answerList.push({
                            qid: data[i].qid,
                            bqid: data[i].bqid ? data[i].bqid : '',
                            value: str
                        })
                    } else if(data[i].questionsTypeId == 207 || data[i].questionsTypeId == 208){
                        let arr = []
                        data[i].optionList.forEach((el) => {
                            arr.push({
                                oid: el.oid,
                                value: el.userAnswer
                            })
                        })
                        answerList.push({
                            qid: data[i].qid,
                            bqid: data[i].bqid ? data[i].bqid : '',
                            optionValue: arr
                        })
                    } else if(data[i].questionsTypeId == 209){
                        let url = ''
                        // console.log(data[i].userAnswer != '')
                        if (data[i].userAnswer != '') {
                            url = await this.DrawingUpQiniu(data[i].userAnswer)
                            // console.log(`url: ${url}`)
                        }
                        answerList.push({
                            qid: data[i].qid,
                            bqid: data[i].bqid ? data[i].bqid : '',
                            value: url ? url : ''
                        })
                    }else if(data[i].questionsTypeId == 210){
                        answerList.push({
                            qid: data[i].qid,
                            bqid: data[i].bqid ? data[i].bqid : '',
                            value: data[i].userAnswerArr.length> 0 ? data[i].userAnswerArr.join(): ''
                        })
                    }else if(data[i].questionsTypeId != 402 && data[i].questionsTypeId != 404 && data[i].questionsTypeId != 401){
                        // console.log(data[i])
                        answerList.push({
                            qid: data[i].qid,
                            bqid: data[i].bqid ? data[i].bqid : '',
                            value: data[i].userAnswer ? data[i].userAnswer : ''
                        })
                    }
                }catch (error) {}
            }
            return answerList
        },
        // 交卷
        async submit(answerState) {
            if (this.dialogthinkVisible) {
                return
            }
            // console.log('tijiao')
            // console.log(this.data.questionsList)
            if (this.isPreviewPc == 0) {
                this.loadingInstance = this.$loading({
                    lock: true,
                    text: '正在提交...',
                    spinner: 'el-icon-loading',
                    background: 'hsla(0,0%,100%,.9)'
                });
                let answerList = await this.getAnswerList(this.data.questionsList)
                
                // console.log('答题结果--------')
                // console.log(answerList)
                // console.log('答题结果--------')
                // return
                if (localStorage.getItem('underwayId')) this.underwayId = localStorage.getItem('underwayId')
                let that = this
                let params = {
                    that: this,
                    url: `${this.$config.service.examUnderwayAddAnswer}`,
                    method: "POST",
                    data: {
                        surveyId: this.id,
                        answerJson: answerList,
                        underwayId: this.underwayId,
                        answerState: answerState ? answerState : 6
                    },
                    cb(res) {
                        that.loadingInstance.close();
                        // console.log(res)
                        // console.log(that.endPageAdvanceMsg)
                        // console.log(that.endPageNormalMsg)
                        that.endMsg = that.endPageNormalMsg
                        if(res.code == '0') {
                            that.WXViewResults()
                            that.dialogthinkVisible = true
                            if (localStorage.getItem(that.id)) {
                                localStorage.removeItem(that.id)
                            }
                            if (that.continueDialogVisible == true) {
                                that.continueDialogVisible = false
                            }
                            // 开启（每台设备答题次数）
                            // if (that.quanxian.pcPhoneAnswerNumState == 1) {
                            //     let num = localStorage.getItem(`${that.id}Num`)
                            //     localStorage.setItem(`${that.id}Num`, parseInt(num) + 1)
                            // }
                            that.continueBeforClose()
                            that.userRemoveEventListener()
                            that.cutScreenCheckRemove()
                            if (that.isPc) {
                                that.$refs.AppearancePC.changeCountDown()
                            } else {
                                that.$refs.AppearanceTM.changeCountDown()
                            }
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            });
                        }
                    },
                };
                params.isnologin = true
                this.$util.request(params)
            } else {
                this.$notify({
                    title: '提示',
                    message: '当前为预览页面，答案不被记录。'
                });
            }
            
        },
        confirmPassword() {
            this.getData(1)
        },
        // 试卷随机
        shuffle(array){
            let lists = [], arr = [], res = [],
            index = 0
            array.forEach((info, index) =>{
                
                if (info.questionsTypeId == 402 || info.questionsTypeId == 404) {
                    arr.push(info)
                    lists.push(arr)
                    arr = []
                } else {
                    arr.push(info)
                }
                if (index == array.length - 1){
                    lists.push(arr)
                }
                
            })
            lists.forEach((info) => {
                info = this.suiji(info)
                res.push(...info)
            })
            res.forEach((item) => {
                // console.log(examQuestionTypeArr.indexOf(item.questionsTypeId) != -1)
                if (this.examQuestionTypeArr.indexOf(item.questionsTypeId) != -1) {
                    item.quesIndex = index
                    index++
                }
            })
            return res
        },
        suiji(array) {
            let res = [], random, userInfoArr = [] , quesArr = [], pageArr = []
            array.forEach(info =>{
                if (info.questionsTypeId === 600) {
                    userInfoArr.push(info)
                } else if (info.questionsTypeId === 402 || info.questionsTypeId === 404) {
                    pageArr.push(info)
                } else {
                    quesArr.push(info)
                }
            })
            while(quesArr.length>0){
                random = Math.floor(Math.random()*quesArr.length);
                res.push(quesArr[random]);
                quesArr.splice(random, 1);
            }
            return [...userInfoArr, ...res, ...pageArr]
        },
        clearEventListener() {
            document.removeEventListener('contextmenu', this.preventEvent)
            document.removeEventListener('copy', this.preventEvent)
            document.removeEventListener('cut', this.preventEvent)
            document.removeEventListener('paste', this.preventEvent)
            document.removeEventListener('dragstart', this.preventEvent)
            document.removeEventListener('drop', this.preventEvent)
            document.removeEventListener('selectstart', this.preventEvent)
            document.removeEventListener('keydown', this.preventDevToolsShortcuts)
        }
    },
    
    beforeDestroy() {
        this.cutScreenCheckRemove()
        this.userRemoveEventListener()
        this.clearEventListener()
    }
}
</script>
<style>
/* 禁止文本选择 */
body {
  -webkit-user-select: none;  /* Chrome, Safari, Opera */
  -moz-user-select: none;     /* Firefox */
  -ms-user-select: none;      /* Internet Explorer/Edge */
  user-select: none;          /* 标准语法 */
  
  -webkit-touch-callout: none; /* 禁止长按菜单（移动端） */
}
</style>
<style lang="scss" scoped>
.content{
    width: 100%;
    min-height: 100vh;
    background-color: #fff;
    margin: auto;
    &_row{
        // width: 1400px;
        // width: 74%;
        width: 100%;
        min-height: 100vh;
        margin-left: auto !important;
        margin-right: auto !important;
        background: aliceblue;
        display: flex;
        align-items: center;
        justify-content: center;
        .content_center{
            .header{
                border-radius: 2px !important;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                .title{
                    font-weight: 650;
                    font-style: normal;
                    font-size: 22px;
                    color: #797979;
                    text-align: center;
                }
                // .info{
                //     display: flex;
                //     justify-content: space-between;
                //     align-items: center;
                //     font-weight: 100;
                //     font-size: 16px;
                //     margin-top: 20px;
                //     .info_num span+span{
                //         display: inline-block;
                //         margin-left: 10px;
                //     }
                    
                //     .info_time_box{
                //         display: flex;
                //         align-items: center;
                //         .progress_box{
                //             display: flex;
                //             align-items: center;
                //             margin-left: 20px;
                //             .progress{
                //                 width: 150px;
                //             }
                //         }
                //     }
                // }
            }
            .ques_box{
                padding: 0 50px 50px 50px;
                font-weight: 650;
                font-style: normal;
                font-size: 15px;
                .list{
                    margin-top: 50px;
                }
                .ques_list{
                    .ques_list_item{
                        margin-top: 10px;
                    }
                    .title{
                        width: 100px;
                    }
                    .input {
                        width: 220px;
                    }
                }
                
                
            }
            .pages, .footer-box{
                text-align: center;
            }
        }
        
    }
    .isNotStartTime,.submittedSuccess{
        text-align: center;
        background-color: #fff;
        padding: 70px;
        margin-top: 100px;
        .title{
            font-weight: 650;
            font-size: 23px;
            color: #169BD5;
        }
        .tips{
            font-size: 17px;
            background-color: rgba(234, 242, 248, 1);
            margin: 50px 135px;
            line-height: 50px;
        }
        .date{
            font-size: 17px;
            color: #D40B0B;
        }
    }
    .submittedSuccess{
        margin-top: 0;
        padding: 0 10px;
        .tips{
            margin: 50px 0 !important;
        }
        .thank{
            font-size: 16px;
            color: #F63E35;
            .link{
                color: #5D90DF;
                cursor: pointer;
            }
            .link+.link{
                display: inline-block;
                margin-left: 5px;
                
            }
        }
        
    }
    .isPassword{
        text-align: center;
        background-color: #fff;
        padding: 70px;
        margin-top: 100px;
        .input_box{    
            width: 50%;
            margin: auto;
            position: relative;
            .form-item__error{
                color: #f56c6c;
                font-size: 12px;
                line-height: 1;
                padding-top: 4px;
                position: absolute;
                top: 92px;
            }
            /deep/.input__err>.el-input__inner{
                border-color: #f56c6c;
            }
        }
        .title{
            font-weight: 650;
            font-size: 18px;
            color: #333333;
        }
        .input{
            margin: 50px 0;
            width: 100%;
        }
        .btn{
            padding: 10px 40px;
        }
    }
}

.required::before{
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
}
.selected{
    border: 1px solid #bae4f6 !important;
    background: #e8fbff;
    color: #2196f3;
}
.itemC{
    display: flex;
    align-items: center;
}

.tips-box{
    background: #fff;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 60%;
    height: 25%;
    margin: auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    border-radius: 5px;
    padding: 20px;
    .title{
        font-size: 16px;
        padding-bottom: 50px;
    }
}
.isWx-content{
    width: 100%;
    background-color: #7c7c7c;
    height: 100vh;
    .isWX-tips-box{
        background-color: #fff;
        text-align: center;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 60%;
        height: 14%;
        margin: auto;
        border-radius: 5px;
        padding: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        .title{
            font-size: 16px;
            padding-bottom: 20px;
        }
        .tips-describe{
            font-size: 14px;
            color: #ccc;
        }
    }
    .wx-login{
        background-color: #3aae54;
        color: #fff;
    }
}
.isWx-content-pc{
    .isWX-tips-box{
        width: 16%;
        min-width: 245px;
        height: 317px;
        padding: 20px;
        box-sizing: border-box;
    }
    .qrCode-img{
        margin-bottom: 10px;
    }
}
.TM-content{
    background: aliceblue;
    width: 100%;
    height: 100vh;
}
.TM-tips-box, .TM-continue-tips-box{
    background: #fff;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 88%;
    height: 17%;
    margin: auto;
    border-radius: 5px;
    padding: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    .title{
        font-weight: 650;
        font-size: 16px;
        color: #169BD5;
    }
    .tips{
        font-size: 14px;
        background-color: #eaf2f8;
        margin: 11px 0;
        line-height: 30px;
    }
    .date{
        font-size: 14px;
        color: #D40B0B;
    }
} 
.TM-continue-tips-box {
    .title {
        margin-bottom: 40px;
        font-weight: normal;
        font-size: 16px;
        color: #000;
    }
}
.TM-isPassword{
    background: #fff;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 88%;
    height: 25%;
    margin: auto;
    border-radius: 5px;
    padding: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    .input_box{
        position: relative;
        .form-item__error{
            color: #f56c6c;
            font-size: 12px;
            line-height: 1;
            padding-top: 4px;
            position: absolute;
            top: 66px;
            left: 29px;
        }
        /deep/.input__err>.el-input__inner{
            border-color: #f56c6c;
        }
    }
    .title{
        font-weight: 650;
        font-size: 16px;
        color: #333333;
        padding-top: 10px;
    }
    .input{
        margin: 24px 0;
        width: 83%;
    }
    .btn{
        padding: 10px 40px;
    }
}
.TM-Dialog{
    /deep/.el-dialog__body{
        padding: none
    }
}
.TM-submittedSuccess{
    text-align: center;
    background-color: #fff;
    padding: 10px;
    .title{
        font-weight: 650;
        font-size: 16px;
        color: #169BD5;
    }
    .tips{
        font-size: 14px;
        background-color: #eaf2f8;
        margin: 11px 0;
        line-height: 30px;
    }
    .thank{
        font-size: 14px;
        color: #F63E35;
        .link{
            color: #5D90DF;
            cursor: pointer;
        }
        .link+.link{
            display: inline-block;
            margin-left: 5px;
            
        }
    }
}
</style>